import { HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

import { TVP_BOTTOM_TOOLBAR } from '../components/layout/layout.component';

@Injectable({
  providedIn: 'root',
})
export class HttpErrorResponseHandlerService {
  constructor(
    private router: Router,
    @Inject(TVP_BOTTOM_TOOLBAR) private hasBottomToolbarSubject: BehaviorSubject<boolean>
  ) {}

  handle(errorResponse: HttpErrorResponse): void {
    this.hasBottomToolbarSubject.next(false);
    const errorType = errorResponse?.error?.type;
    this.router.navigate(['/appointment/error'], {
      queryParams: { errorType },
      skipLocationChange: true,
    });
  }
}
